<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    @if (formField.label) {
        <label for="form-element-{{ formField.id }}" (click)="selectElement?.focus()" class="form-element-label">
            {{ formField.label }}{{ formField.isRequired ? ' *' : '' }}
        </label>
    }
    @if (!isMobileOrTabletDevice()) {
        <div class="form-group store-info-selector">
            <ng-select
                name="formField{{ formField.id }}Brand"
                id="form-element-{{ formField.id }}"
                bindLabel="value"
                bindValue="value"
                class="select-control"
                #select
                appSelectAccessibility
                [inputAriaLabelAttribute]="formField.options?.brandPlaceholder || 'brand combobox'"
                appFocus
                [appAutoFocus]="formField.isNeedToFocus"
                [focusableSelectElement]="selectElement"
                (change)="onSelect($event, 'brand')"
                [ngClass]="{ 'ng-invalid': formField.isRequired && !formField.valueModel[0] }"
                placeholder="{{ formField.options?.brandPlaceholder }}{{ formField.isRequired ? ' *' : '' }}"
                [items]="formField.possibleValues"
                [required]="formField.isRequired"
                [(ngModel)]="formField.valueModel[0]">
            </ng-select>
            @if (formService.isSubmitted && !formField.valueModel[0] && formField.isRequired) {
                <div class="text-danger" translate>Please fill this field</div>
            }
        </div>

        @if (formField.valueModel[0] && stores.length) {
            <div class="form-group store-info-selector">
                <ng-select
                    name="formField{{ formField.id }}PurchaseRegion"
                    bindLabel="value"
                    bindValue="value"
                    class="select-control"
                    appSelectAccessibility
                    [inputAriaLabelAttribute]="formField.options?.regionPlaceholder || 'region combobox'"
                    (change)="onSelect($event, 'region')"
                    [ngClass]="{ 'ng-invalid': formField.isRequired && !formField.valueModel[1] }"
                    placeholder="{{ formField.options?.regionPlaceholder }}{{ formField.isRequired ? ' *' : '' }}"
                    [items]="stores"
                    [required]="formField.isRequired"
                    [(ngModel)]="formField.valueModel[1]">
                </ng-select>
                @if (formService.isSubmitted && formField.isRequired && !formField.valueModel[1]) {
                    <div class="text-danger" translate>Please fill this field</div>
                }
            </div>
        }

        @if (formField.valueModel[1] && regionStores.length) {
            <ng-select
                name="formField{{ formField.id }}PurchaseStore"
                bindLabel="value"
                bindValue="value"
                class="select-control"
                appSelectAccessibility
                [inputAriaLabelAttribute]="formField.options?.storePlaceholder || 'store combobox'"
                [placeholder]="formField.options?.storePlaceholder"
                [items]="regionStores"
                [(ngModel)]="formField.valueModel[2]">
            </ng-select>
        }
    } @else {
        <div class="form-group store-info-selector">
            <select
                class="form-control"
                name="formField{{ formField.id }}Brand"
                id="form-element-{{ formField.id }}"
                [title]="formField.options?.brandPlaceholder || 'brand selector'"
                (ngModelChange)="onSelectFromMobile($event, 'brand', formField.possibleValues)"
                [ngClass]="{
                    'ng-invalid': formField.isRequired && !formField.valueModel[0],
                    'select-placeholder': formField.valueModel[0],
                }"
                [(ngModel)]="formField.valueModel[0]"
                [required]="formField.isRequired">
                <option [ngValue]="null">
                    <span>{{ formField.options?.brandPlaceholder }}{{ formField.isRequired ? ' *' : '' }}</span>
                </option>
                @for (option of formField.possibleValues; track option) {
                    <option [ngValue]="option.value">
                        {{ option.value }}
                    </option>
                }
            </select>
        </div>

        @if (formField.valueModel[0] && stores.length) {
            <div class="form-group store-info-selector">
                <select
                    class="form-control"
                    name="formField{{ formField.id }}PurchaseRegion"
                    [title]="formField.options?.regionPlaceholder || 'region selector'"
                    (ngModelChange)="onSelectFromMobile($event, 'region', stores)"
                    [ngClass]="{
                        'ng-invalid': formField.isRequired && !formField.valueModel[1],
                        'select-placeholder': formField.valueModel[1],
                    }"
                    [(ngModel)]="formField.valueModel[1]"
                    [required]="formField.isRequired">
                    <option [ngValue]="null">
                        <span>{{ formField.options?.regionPlaceholder }}{{ formField.isRequired ? ' *' : '' }}</span>
                    </option>
                    @for (option of stores; track option) {
                        <option [ngValue]="option.value">
                            {{ option.value }}
                        </option>
                    }
                </select>
            </div>
        }

        @if (formField.valueModel[1] && regionStores.length) {
            <select
                class="form-control"
                name="formField{{ formField.id }}PurchaseStore"
                [title]="formField.options?.storePlaceholder || 'store selector'"
                [ngClass]="{ 'select-placeholder': formField.valueModel[2] }"
                [(ngModel)]="formField.valueModel[2]">
                <option [ngValue]="null">
                    <span>{{ formField.options?.storePlaceholder }}</span>
                </option>
                @for (option of regionStores; track option) {
                    <option [ngValue]="option.value">
                        {{ option.value }}
                    </option>
                }
            </select>
        }
    }
</div>
